import gui	from "gui";
import Dialog	from "dialog";
import html	from "../html/dialog-shutdown.html";
import css 	from "../css/dialog-shutdown.css";

class ShutdownDialog extends Dialog {
	static get template() {
			return html;
	}
	static get css() {
			return css;
	}
	static constructor() {
		customElements.define("fulljs-dialog-shutdown", ShutdownDialog);
	}
	constructor(p) {
		super(p);
		this.show();
	}
	get message() {
		return this._labelMessage.value;
	}
	set message(message) {
		this._labelMessage.value = message;
	}
}

ShutdownDialog.constructor();

export default ShutdownDialog;